import React, { FC } from 'react';
import { Modal } from 'react-bootstrap';
import './style/scss/CancelWaitRemove.index.scss';

export interface DataType {
  data_id: number;
  contents_annex_flag: number | null;
  contents_web_show_name: string | null;
  club_equipment_annex_flag: number | null;
  club_web_show_name: string | null;
  reserve_time_label: string | null;
}

interface Props {
  show: boolean;
  data: DataType;
  handle: (dataId: number) => () => void;
  onHide: () => void;
}

const CancelWaitRemove: FC<Props> = ({ show, data, handle, onHide }) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      animation
      // className="p-modal-member"
      dialogClassName="p-modal-member__dialog p-modal-member__dialog--width880 cancel-wait-remove-mdl"
      contentClassName="p-modal-member__content"
    >
      {/* <Modal.Header closeButton> */}
      {/*  <Modal.Title>Content Class</Modal.Title> */}
      {/* </Modal.Header> */}

      <Modal.Body className="p-modal-member__body">
        <button type="button" className="p-modal-member__close-button" aria-label="閉じる" onClick={onHide} />

        <div className="p-modal-member__container">
          <div className="p-modal-member__header">
            <div className="p-modal-member__title">
              キャンセル待ち予約を
              <br className="u-sp-only" />
              解除します。
            </div>
          </div>

          <div className="p-modal-member__inner p-modal-member__inner--padding-x80 u-gap15">
            {/* <!--  / 説明文 --> */}
            <div className="p-modal-member__text u-pb15">
              一度解除したキャンセル待ち予約は
              <br className="u-sp-only" />
              元に戻すことはできません。
              <br />
              内容をご確認の上、よろしければ
              <br className="u-sp-only" />
              「キャンセル待ちを解除する」ボタンを押してください。
            </div>

            {/* <!--  予約内容 --> */}
            <div className="p-reservation-card u-sp-gap10">
              <div className="p-reservation-card__header p-reservation-card__header--modal">
                <div className="p-reservation-card__row-text">
                  {data.club_web_show_name}
                  {data.contents_annex_flag === 1 ? (
                    <span className="c-genre-label c-genre-label--large">別館</span>
                  ) : (
                    <></>
                  )}
                </div>
                <div className="p-reservation-card__title">{data.contents_web_show_name}</div>
              </div>

              <div className="p-reservation-card__details p-reservation-card__details--padding-x40">
                <dl className="p-detail-list u-gap7">
                  <div className="p-detail-list__item">
                    <dt className="p-detail-list__label">実施日時</dt>
                    <dd className="p-detail-list__value">{data.reserve_time_label}</dd>
                  </div>
                  <div className="p-detail-list__accordion-box">
                    <div className="p-detail-list__accordion-label">店舗情報</div>
                    <div className="p-detail-list__accordion-value">
                      {data.club_web_show_name}
                      {data.club_equipment_annex_flag === 1 ? (
                        <span className="c-genre-label c-genre-label--large">別館</span>
                      ) : (
                        <></>
                      )}
                    </div>
                  </div>

                  {/* <div className="p-detail-list__item">
                    <dt className="p-detail-list__label">スペース</dt>
                    <dd className="p-detail-list__value">A・レンタルクラブ設置席</dd>
                  </div>
                  <div className="p-detail-list__item">
                    <dt className="p-detail-list__label">同行者</dt>
                    <dd className="p-detail-list__value">2名</dd>
                  </div> */}
                </dl>
              </div>
            </div>
          </div>

          {/* <!-- ボタン --> */}
          <div className="p-modal-member__button-area">
            <button
              type="button"
              className="c-button c-button--secondary c-button--large c-button--prev-gray"
              onClick={onHide}
            >
              戻る
            </button>
            <button
              type="button"
              className="c-button c-button--primary c-button--large c-button--max-width-auto"
              onClick={handle(data.data_id)}
            >
              キャンセル待ちを解除する
            </button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default CancelWaitRemove;
